export var StandPriority;
(function (StandPriority) {
    StandPriority[StandPriority["low"] = 0] = "low";
    StandPriority[StandPriority["normal"] = 1] = "normal";
    StandPriority[StandPriority["high"] = 2] = "high";
    StandPriority[StandPriority["urgent"] = 3] = "urgent";
})(StandPriority || (StandPriority = {}));
export var StandPriorityColor;
(function (StandPriorityColor) {
    StandPriorityColor[StandPriorityColor["gray"] = 0] = "gray";
    StandPriorityColor[StandPriorityColor["green"] = 1] = "green";
    StandPriorityColor[StandPriorityColor["yellow"] = 2] = "yellow";
    StandPriorityColor[StandPriorityColor["red"] = 3] = "red";
})(StandPriorityColor || (StandPriorityColor = {}));
